import React, { useMemo, useState } from 'react';
import WiringPage, { CompactButtons, WiringSelect } from '../../wiring-page';

import directGw214Img from '../../../../assets/product-interaction/dtsu5168/dtsu5168_direct_gw214.png';
import directGw152Img from '../../../../assets/product-interaction/dtsu5168/dtsu5168_direct_gw152.png';
import directMasterImg from '../../../../assets/product-interaction/dtsu5168/dtsu5168_direct_master_4p.png';
import ctGw214Img from '../../../../assets/product-interaction/dtsu5168/dtsu5168_ct_gw214.png';
import ctGw152Img from '../../../../assets/product-interaction/dtsu5168/dtsu5168_ct_gw152.png';
import ctMasterImg from '../../../../assets/product-interaction/dtsu5168/dtsu5168_ct_master_4p.png';
import ctTripImg from '../../../../assets/product-interaction/dtsu5168/dtsu5168_ct_shunt_trip.png';
import ctPowerImg from '../../../../assets/product-interaction/dtsu5168/dtsu5168_ct_power_wiring.png';

const diagrams = [
  {
    id: 'direct-gw214', type: 'direct', connection: 'gw214',
    title: '直接式接线图', tag: 'GW214', image: directGw214Img,
    imageAlt: 'DTSU5168 直接式电表连接 GW214 网关接线图'
  },
  {
    id: 'direct-gw152', type: 'direct', connection: 'gw152',
    title: '直接式接线图', tag: 'GW152', image: directGw152Img,
    imageAlt: 'DTSU5168 直接式电表连接 GW152 网关接线图'
  },
  {
    id: 'direct-master4p', type: 'direct', connection: 'master4p',
    title: '直接式接线图', tag: '4P 母表', image: directMasterImg,
    imageAlt: 'DTSU5168 直接式电表连接 4P 母表接线图'
  },
  {
    id: 'ct-gw214', type: 'ct', connection: 'gw214',
    title: '互感式接线图', tag: 'GW214', image: ctGw214Img,
    imageAlt: 'DTSU5168 互感式电表连接 GW214 网关接线图'
  },
  {
    id: 'ct-gw152', type: 'ct', connection: 'gw152',
    title: '互感式接线图', tag: 'GW152', image: ctGw152Img,
    imageAlt: 'DTSU5168 互感式电表连接 GW152 网关接线图'
  },
  {
    id: 'ct-master4p', type: 'ct', connection: 'master4p',
    title: '互感式接线图', tag: '4P 母表', image: ctMasterImg,
    imageAlt: 'DTSU5168 互感式电表连接 4P 母表接线图'
  },
  {
    id: 'ct-trip', type: 'ct', connection: 'trip',
    title: '互感式特殊接线', tag: '分励脱扣器', image: ctTripImg,
    imageAlt: 'DTSU5168 互感式电表连接分励脱扣器接线图'
  },
  {
    id: 'ct-power', type: 'ct', connection: 'power',
    title: '互感式特殊接线', tag: '电源接线', image: ctPowerImg,
    imageAlt: 'DTSU5168 互感式电表电源接线图'
  }
];

const typeOptions = [
  { value: 'all', label: '全部' },
  { value: 'direct', label: '直接式' },
  { value: 'ct', label: '互感式' }
];

const commonConnectionOptions = [
  { value: 'all', label: '全部接线' },
  { value: 'gw214', label: 'GW214' },
  { value: 'gw152', label: 'GW152' },
  { value: 'master4p', label: '4P母表' }
];

const ctConnectionOptions = [
  ...commonConnectionOptions,
  { value: 'trip', label: '分励脱扣器' },
  { value: 'power', label: '电源接线' }
];

const DTSU5168Wiring = () => {
  const [type, setType] = useState('all');
  const [connection, setConnection] = useState('all');

  const handleTypeChange = (value) => {
    setType(value);
    setConnection('all');
  };

  const visibleDiagrams = useMemo(() => diagrams.filter((diagram) => {
    if (type !== 'all' && diagram.type !== type) return false;
    return type === 'all' || connection === 'all' || diagram.connection === connection;
  }), [type, connection]);

  const filters = (
    <>
      <CompactButtons
        ariaLabel="接入方式"
        options={typeOptions}
        value={type}
        onChange={handleTypeChange}
      />
      {type !== 'all' && (
        <WiringSelect
          ariaLabel="接线类型"
          options={type === 'ct' ? ctConnectionOptions : commonConnectionOptions}
          value={connection}
          onChange={setConnection}
        />
      )}
    </>
  );

  return (
    <WiringPage
      documentTitle="DTSU5168 接线图｜源一物联"
      heading="DTSU5168"
      backUrl="/product/dtsu5168"
      filters={filters}
      diagrams={visibleDiagrams}
    />
  );
};

export default DTSU5168Wiring;
